export const middlewareConstants = {
    REFRESH: 'MIDDLEWARE_REFRESH',
    CLEAR: 'MIDDLEWARE_CLEAR'
};
